/* eslint-disable eag/match-named-export */
import {Integer} from 'platform/foundation';

export type TreeFolderContextTarget = 'labour-catalog' | 'spare-parts-catalog';

export type TreeFolderRelationTarget = 'labour-catalog-item' | 'spare-parts-catalog-item';
export type TreeFolderAction = 'addFolder' | 'addRelation' | 'edit' | 'delete';
export type TreeFolder = {
  id?: string | null;
  contextId?: string;
  label?: string | null;
  level?: Integer | null;
  parentId?: string | null;
  actions?: (TreeFolderAction | null)[];
  subfolders?: (TreeFolder | null)[];
};
export type TreeFolderPathType = {
  id?: string | null;
  label?: string | null;
  pathName?: string | null;
};
export type GetTreeFolderApiResponse =
  | /** status 200 Standard response */ ({
      treeFolder?: TreeFolder | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetTreeFolderApiArg = {
  contextTarget: TreeFolderContextTarget;
  contextId: string;
};
export type GetTreeFoldersApiResponse = {
  treeFolders: TreeFolder[];
};
export type GetTreeFoldersApiArg = {
  contextTarget: TreeFolderContextTarget;
  body: {
    contextIds: string[];
  };
};
export type GetTreeFolderPathApiResponse = {
  treeFolder?: TreeFolderPathType | null;
};
export type GetTreeFolderPathApiArg = {
  leafId: string;
};
export type DeleteTreeFolderApiResponse = /** status 204 Standard response */ undefined;
export type DeleteTreeFolderApiArg = {
  leafId: string;
  contextId: string;
  contextTarget: TreeFolderContextTarget;
};
export type PatchTreeFolderApiResponse = /** status 204 Standard response */ undefined;
export type PatchTreeFolderApiArg = {
  contextTarget: TreeFolderContextTarget;
  contextId: string;
  leafId: string;
  body: {
    name: string;
  } | null;
};
export type PutTreeFolderRelationsApiResponse = /** status 204 Standard response */ undefined;
export type PutTreeFolderRelationsApiArg = {
  contextTarget: TreeFolderContextTarget;
  contextId: string;
  leafId: string;
  body: {
    relation?: {
      target: TreeFolderRelationTarget;
      ids?: string[];
    } | null;
  } | null;
};
export type PostTreeFolderParentApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTreeFolderParentApiArg = {
  contextTarget: TreeFolderContextTarget;
  contextId: string;
  body: {
    name: string;
  } | null;
};
export type PostTreeFolderChildApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTreeFolderChildApiArg = {
  contextTarget: TreeFolderContextTarget;
  contextId: string;
  parentId: string;
  body: {
    name: string;
  } | null;
};
